import { render } from "./InspectRecipientModal.vue?vue&type=template&id=62f5befa&scoped=true&ts=true"
import script from "./InspectRecipientModal.vue?vue&type=script&lang=ts"
export * from "./InspectRecipientModal.vue?vue&type=script&lang=ts"

import "./InspectRecipientModal.vue?vue&type=style&index=0&id=62f5befa&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62f5befa"]])

export default __exports__